/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/263-point-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9.5 15H7a1.502 1.502 0 01-1.307-2.236 1.5 1.5 0 01-.31-2.264A1.494 1.494 0 015.086 9H1.5C.673 9 0 8.327 0 7.5S.673 6 1.5 6h6.167L6.201 3.25a1.502 1.502 0 012.381-1.789l.011.012L12 5.21V4.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-.691l-2.276 1.138A.496.496 0 019.5 15zm4-1a.5.5 0 100-1 .5.5 0 000 1zm-4.118 0L12 12.691V6.694L7.857 2.15a.5.5 0 00-.782.614l1.866 3.5a.499.499 0 01-.441.735h-7a.5.5 0 000 1h5a.5.5 0 010 1 .5.5 0 000 1 .5.5 0 010 1 .5.5 0 000 1H7a.5.5 0 010 1 .5.5 0 000 1h2.382z"/>'
  }
})
